import React from "react";
import VerifyCertificate from "./VerifyCertificate";

function App() {
  return (
    <div>
      <VerifyCertificate />
    </div>
  );
}

export default App;
